// extracted by mini-css-extract-plugin
module.exports = {"logoBackground":"SideBar_logoBackground_1I5cn","sideBarWrap":"SideBar_sideBarWrap_2IdRm","servicesList":"SideBar_servicesList_HBofg","contacts":"SideBar_contacts_3XnU3"};